import './BarcodeDialog.scss';

import JsBarcode from 'jsbarcode';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SplitButton } from 'primereact/splitbutton';
import { useCallback, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TransportEntitiesType } from '../TransportEntities.functions';
import { getDownloadButtonItems } from './BarcodeDialog.functions';

type Props = {
  data: TransportEntitiesType | null;
  isShown: boolean;
  onHide: () => void;
};

function BarcodeDialog({ data, isShown, onHide }: Props) {
  const { t } = useTranslation();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const barcode = data?.barcode;

  const setBarcodeCanvas = useCallback(
    (canvas: HTMLCanvasElement | null) => {
      canvasRef.current = canvas;

      if (canvas && barcode) {
        JsBarcode(canvas, barcode, {
          format: 'CODE128',
          displayValue: false,
          width: 2,
          height: 80,
        });
      }
    },
    [barcode]
  );

  const dialogFooter = (
    <Button type="button" label="Close" onClick={onHide} data-cy="close-btn" />
  );

  const downloadButtonItems = useMemo(
    () => getDownloadButtonItems(t, data, canvasRef),
    [data, t]
  );

  return (
    <Dialog
      visible={isShown}
      onHide={onHide}
      header={t('Barcode')}
      footer={dialogFooter}
      dismissableMask
      resizable={false}
      className="transport-entities-barcode-dialog"
    >
      <div className="info-item">
        <h4>{t('Transport entity type')}</h4>
        <span>{data?.transportEntityType?.name}</span>
      </div>

      <div className="info-item">
        <h4>{t('Barcode')}</h4>
        <span>{data?.barcode}</span>
      </div>

      {isShown && data?.barcode && (
        <canvas ref={setBarcodeCanvas} className="barcode" />
      )}

      <div className="p-mt-2 p-text-center">
        <SplitButton
          label={t('Download')}
          model={downloadButtonItems}
          onClick={downloadButtonItems[0].command}
          className="p-button-secondary"
        />
      </div>
    </Dialog>
  );
}

export default BarcodeDialog;
